<template>
  <b-card
    v-if="dataList"
    no-body
  >
    <b-card-header>
      <b-card-title>Açık Teklifler</b-card-title>
      <b-button
        variant="flat-primary"
        size="sm"
        pill
        to="/offers"
      >
        Tüm Teklifleri Görüntüle
      </b-button>
    </b-card-header>
    <b-table
      :items="dataList"
      responsive
      :fields="fields"
      class="mb-0"
    >
      <template #cell(onum)="data">
        <b-link
          :to="'/offers/view/' + data.item.id"
          class="font-weight-bold text-body"
        >
          {{ data.item.onum }}
          <span
            v-if="data.item.onum_rno"
            class="text-danger"
          >
            R{{ data.item.onum_rno }}
          </span>
        </b-link>
      </template>
      <template #cell(name)="data">
        <b-link
          :to="'/offers/view/' + data.item.id"
          class="font-weight-bold text-body"
        >
          <div class="font-weight-bold">
            {{ data.item.company }}
          </div>
          <div class="text-primary">
            {{ data.item.title }}
          </div>
          <div class="text-muted font-small-3">
            {{ data.item.name }}
          </div>
        </b-link>
      </template>
      <template #cell(offer_status)="data">
        <div>
          <b-badge
            :variant="data.item.status_variant"
            class="w-100"
          >
            {{ data.item.offer_status }}
          </b-badge>
        </div>
        <div class="mt-1">
          <b-badge
            variant="light-secondary"
            class="w-100"
          >
            {{ data.item.username }}
          </b-badge>
        </div>
      </template>
      <template #cell(control)="data">
        <b-button
          :to="'/offers/view/' + data.item.id"
          variant="outline-primary"
          size="sm"
        >
          Görüntüle
        </b-button>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCount"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BBadge, BButton, BPagination, BCardFooter, BCardHeader, BCardTitle, BLink,
} from 'bootstrap-vue'

export default {
  components: {
    BCardFooter,
    BPagination,
    BCard,
    BTable,
    BBadge,
    BButton,
    BCardHeader,
    BCardTitle,
    BLink,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: 'onum',
          label: 'TEKLİF NO',
          thClass: 'text-nowrap width-100',
          tdClass: 'text-nowrap width-100',
        },
        {
          key: 'name',
          label: 'FİRMA ADI / İLGİLİ KİŞİ',
        },
        {
          key: 'offer_status',
          label: 'DURUM',
          thClass: 'text-nowrap width-100',
          tdClass: 'text-nowrap width-100',
        },
      ],
      dataQuery: {
        select: [
          'offers.id AS id',
          'offers.onum AS onum',
          'offers.onum_rno AS onum_rno',
          'offers.title AS title',
          'offer_status.title AS offer_status',
          'offer_status.variant AS status_variant',
          'users.name AS username',
          'customers.company AS company',
          'offers.name AS name',
        ],
        where: {
          'id_offer_status <=': 3,
        },
        limit: 10,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['offers/getOffers']
    },
    dataCount() {
      return this.$store.getters['offers/getOffersCount']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 10
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      this.$store.dispatch('offers/offersList', this.dataQuery)
    },
  },
}
</script>
